import { z } from './utils/zod.js';
import { signerComponentSchema, signerRoleSchema, signingDocumentSchema } from './signings.js';
import { successResponse, errorResponse, listResponse, deleteResponse, dataResponse } from './utils/response-templates.js';
export const placeholderSignerRequestSchema = z.object({
    id: z.string().uuid(),
    name: z.string().trim().min(1).max(150),
    role: signerRoleSchema,
    components: z.array(signerComponentSchema).nullable(),
    color: z.string().max(50),
});
export const createTemplateRequestSchema = z.object({
    name: z.string().max(150),
    signatureType: z.string().max(150).nullable(),
    signers: z.array(placeholderSignerRequestSchema),
    documentOrder: z.array(z.string().uuid()).optional(),
});
export const updateTemplateRequestSchema = createTemplateRequestSchema;
export const templateDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string().max(150),
    documents: z.array(signingDocumentSchema),
    signatureType: z.string().max(50).nullable(),
    signers: z.array(placeholderSignerRequestSchema),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createTemplateResponseSchema = successResponse().extend({
    data: templateDtoSchema,
});
export const ListTemplateDtoSchema = templateDtoSchema.omit({ documents: true });
export const listTemplatesResponseSchema = listResponse(ListTemplateDtoSchema);
export const deleteTemplateResponseSchema = deleteResponse();
export const templateInvalidResponseSchema = errorResponse('Invalid template');
export const templateStartRequestSchema = z.object({
    name: z.string().max(150),
    signers: z.array(z.object({
        id: z.string().uuid(),
        name: z.string().trim().min(1).max(150),
        email: z.string().commonEmail(),
        phone: z.string().phoneNumber('Invalid phone number', { emptyStringAllowed: true }).optional(),
        color: z.string().max(50),
        contactId: z.string().uuid().nullable().optional(),
        needsLogin: z.boolean().optional(),
    })),
});
export const templateStartResponseSchema = dataResponse(z.object({
    signingId: z.string().uuid(),
}));
